// extracted by mini-css-extract-plugin
export default {"zoomModal":"R3-z","image":"S3-z","button":"T3-z","isOverlayShown":"U3-z"};